<script>
import * as R from 'ramda'
import tap from 'tap-logger'

export default {
	props:[
		'headerCopy',
		'productsCopy',
		'totalCopy',
		'viewCartCopy',
		'cartPageLink',
		'goToShopCopy',
		'checkoutLink',
		'cart',
	],

	data() {
		return {
		}
	},

	methods: {
		removeFromCart(id) {
			let url = R.replace('__id__', id, this.$root.store.routes.removeFromCart.post || '/cart/delete-item/__id__')
			this.$http.post(url, {
				_method: 'DELETE',
				_token: this.$root.store.csrf_token
			})
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.$root.alert(body)
					this.$root.store.cart.data = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

		toggleOpen() {

			this.$root.store.menus.cart.isOpen = !this.isOpen
		},

		open() {

			this.$root.store.menus.cart.isOpen = true
		},

		close() {
			this.$root.store.menus.cart.isOpen = false
		}
	},
	computed: {
		links() {
			let {cartIndex, checkout} = this.$root.store.routes.get
			return {cartIndex, checkout}
		},

		copies() {
			this.$root.store.copies.menuCart.productsCopy= "Agregado al carro";
			this.$root.store.copies.menuCart.cartEmpty = "No hay productos en tu carrito";
			this.$root.store.copies.menuCart.viewCartCopy= "Ver Carro";
			this.$root.store.copies.menuCart.goToShopCopy= "Comprar";
			return this.$root.store.copies.menuCart
		},

		isOpen() {
			return this.$root.store.menus.cart.isOpen
		},

		totalPrice() {
			return R.pathOr('$0', ['cart', 'data', 'formated_total'], this)
		},

		subtotalPrice() {
			return R.pathOr('$0', ['cart', 'data', 'formated_subtotal'], this)
		},

		items() {

			return R.pathOr([], ['cart', 'data', 'items'], this)
		},

		totalQuantity() {
			return this.items.length
		},

		shownProducts() {
			return R.pipe(
				R.slice(0, 3),
				R.map(({item_id, thumbnail_url,name, description, formated_buyable_price, quantity,computed_description,computed_title}) => ({
					id: item_id,
					img: thumbnail_url,
					description,
					name,
					price: formated_buyable_price,
					quantity,
					computed_description:computed_description
				})),
			)(this.items)
		}
	}
}
</script>

<template>
    <section class="menu-cart">
        <div class="elements" v-on:click.stop="toggleOpen">
            <div class="elements__buy" v-on:click.stop="toggleOpen">
                <span class="total-price">
                    {{copies.headerCopy}} {{totalPrice}}
                    <span class="moneda-nacional"> MXN</span>
                </span>
                <span class="shopping-bag.header__navbar--carButtonTooltipContainer--icon" aria-hidden="true"></span>
            </div>
            <div class="elements__buy--circle">
                {{totalQuantity}}
            </div>
            <div class="elements__buy--tooltip" v-show="isOpen" v-on:click.stop="">
                <div class="elements__scrollable-container">
                    <p class="elements__buy--ttl" v-if="shownProducts.length == 0">
                        {{copies.cartEmpty}}
                    </p>
                    <div class="relative" v-for="product in shownProducts">
                        <div class="elements__buy--description">
                            <div class="elements__buy--img">
                                <img class="elements__buy--img-size" :src="product.img" />
                            </div>
                            <div class="elements__buy--txt">
                                <p>{{product.name}}</p>
                                <p>{{product.quantity}} x {{product.price}}</p>
                            </div>
                            <div class="elements__buy--icon" v-on:click="removeFromCart(product.id)">
                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div class="elements__buy--subtotal">
                        <p>{{copies.totalCopy}}</p>
                        <p class="elements__buy--price">
                            {{subtotalPrice}} <span class="moneda-nacional">MXN</span>
                        </p>
                    </div>
                    <div class="elements__buy--botones">
                        <a :href="links.cartIndex">{{copies.viewCartCopy}}</a>
                        <a :href="links.checkout">{{copies.goToShopCopy}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.elements {
	&__buy--icon i {
		padding: 5px;
		cursor: pointer;
		top: 5px;
		right: -2px;
	}

	&__scrollable-container {
		max-height: calc(100vh - 100px);
		overflow-y: auto;
		overflow-x: hidden;
		width: calc(100% + 20px);//espacio para la barra de scroll, si aparece
 	   	padding-right: 20px;
	}
}

</style>



// WEBPACK FOOTER //
// menu-cart.vue?89ad4528